import { useQuery } from '@tanstack/react-query';
import { collaboratorService } from '@/features/Collaborators/Services';
import { useSalaryPermissions } from '@/features/Collaborators/hooks/useSalaryPermissions';
import { fetchCollaboratorSalary, convertToLegacyFormat } from '@/features/Collaborators/Services/salarySubcollectionService';
import { Collaborator } from '@/features/Collaborators/Models/collaborator';

export const collaboratorQueryKeys = {
    all: ['collaborators_private'] as const,
    detail: (email: string) => ['collaborator', email] as const,
};

export const useCollaboratorByIdQuery = (id?: string) => {
    const { canViewSalary } = useSalaryPermissions();

    return useQuery({
        queryKey: ['collaborator', id, canViewSalary],
        queryFn: async () => {
            if (!id) {
                return Promise.resolve(null);
            }

            // Fetch collaborator main document
            const collaborator = await collaboratorService.getCollaboratorById(id);

            if (!collaborator) {
                return null;
            }

            // If user can't view salary, return as-is
            if (!canViewSalary) {
                return collaborator;
            }

            // Fetch salary data from subcollection
            try {
                const salaryData = await fetchCollaboratorSalary(id);

                if (!salaryData || !salaryData.current) {
                    // No salary data found, return collaborator as-is
                    return collaborator;
                }

                // Convert to legacy format and merge
                const legacyFormat = convertToLegacyFormat(salaryData);

                return {
                    ...collaborator,
                    ...legacyFormat
                } as Collaborator;
            } catch (error) {
                console.error('Error fetching salary data for form:', error);
                // On error, return collaborator without salary data
                return collaborator;
            }
        },
        enabled: !!id, // A query só será executada se o ID existir
    });
}; 